import Repository from './Repository';
const resource = '/v1/loans';

export default {
  get() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}`)
        .then(response => {
          resolve(response.data.data.loans);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  }
}
